// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__mF3AH","clinicsSelect":"TableHeading_clinicsSelect__MAgPO"};